import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import dayjs from "dayjs";

export default class OrderLogResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "log_history" : [{
                    "executor": "fakeUser@123.com",
                    "action": "Added Article",
                    "execution_timestamp": "23-04-2025 15:24",
                }]
            },
            errors: []
        }
    }

    orderLog() {
         return this.content().map(orderActionRegister => {
            return  {
                executor: orderActionRegister.executor,
                action: orderActionRegister.action,
                executionTimestamp: this._adaptExecutionTimestamp(orderActionRegister.execution_timestamp),
            }
        })
    }

    _adaptExecutionTimestamp(executionTimestamp) {
        return dayjs(executionTimestamp, 'YYYY-MM-DD HH:mm:ss');
    }
}
